import ui from './ui'
import configuration from './configuration'
import financialCompany from './financialCompany'
import enabledFinancialModules from './enabledFinancialModules'

export default {
  ui,
  configuration,
  financialCompany,
  enabledFinancialModules
}
